import React from 'react';
import PropTypes from 'prop-types';

export const MultiView = props => {
  const { children, attendees, ...restOfProps } = props;
  const attendeeNm = child => JSON.parse(child.props.stream.connection.data).userName

  const renderSignature = (attendeeName) => (
    <div className="attendee_title">
      <h3>{attendeeName}</h3>
    </div>
  );

  const attendeesElements = child => (
    <div className={`attendee ${child.props.userType}`}>
      {React.cloneElement(child, { ...restOfProps })}
      {renderSignature(attendeeNm(child), child)}
    </div>
  );

  return (
    <div className={attendees.length > 1 ? 'multi-view' : 'single-view'}>
      {React.Children.map(children, child => attendeesElements(child))}
    </div>
  );
};

MultiView.propTypes = {
  children: PropTypes.node
};
